
const newModel = () => {
    return {
        truongchuanQuocgiaLophocId: null,
        truongchuanQuocgiaId: null,
        tenTruongchuanQuocgia: null,
        idKy: null,
        tenKy: null,
        solopTieuhoc: 0,
        solopThcs: 0,
        solopGhep: 0,
        solopThpt: 0,
        solopGdtx: 0,
        ghiChu: null,
        enabled: null,
        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null

    }
}

const newFEModel = () => {
    return {
        truongchuanQuocgiaLophocId: null,
        truongchuanQuocgiaId: null,
        idKy: null,
        solopTieuhoc: 0,
        solopThcs: 0,
        solopGhep: 0,
        solopThpt: 0,
        solopGdtx: 0,
        ghiChu: null,
        enabled: true,
        iocId: null,
        iocEnabled: null,
        iocEnabledDisplay: null,
        iocDateUpdated: null,
    }
}

const fromJson = (item) => {
    return {
        truongchuanQuocgiaLophocId: item.truongchuanQuocgiaLophocId,
        truongchuanQuocgiaId: item.truongchuanQuocgiaId,
        tenTruongchuanQuocgia: item.tenTruongchuanQuocgia,
        idKy: item.idKy,
        tenKy: item.tenKy,
        solopTieuhoc: item.solopTieuhoc,
        solopThcs: item.solopThcs,
        solopGhep: item.solopGhep,
        solopThpt: item.solopThpt,
        solopGdtx: item.solopGdtx,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
        iocDateUpdated: item.iocDateUpdated,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        truongchuanQuocgiaLophocId: item.truongchuanQuocgiaLophocId,
        truongchuanQuocgiaId: item.truongchuanQuocgiaId,
        tenTruongchuanQuocgia: item.tenTruongchuanQuocgia,
        idKy: item.idKy,
        tenKy: item.tenKy,
        solopTieuhoc: item.solopTieuhoc,
        solopThcs: item.solopThcs,
        solopGhep: item.solopGhep,
        solopThpt: item.solopThpt,
        solopGdtx: item.solopGdtx,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
        iocDateUpdated: item.iocDateUpdated,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        truongchuanQuocgiaId: null,
        idKy: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        truongchuanQuocgiaId: item.truongchuanQuocgiaId,
        idKy: item.idKy,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        truongchuanQuocgiaLophocId: null,
        truongchuanQuocgiaId: null,
        tenTruongchuanQuocgia: null,
        idKy: null,
        tenKy: null,
        solopTieuhoc: null,
        solopThcs: null,
        solopGhep: null,
        solopThpt: null,
        solopGdtx: null,
        ghiChu: null,
        enabled: null,
    }
}

export const truongchuanQuocgiaLophocModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


